import * as end from '../constants/api'
import { axiosInstance } from './axios-instance'

const HabitsService = {
	getHabits: ({ userId }) => {
		return axiosInstance.get(end.getHabits({ userId })).then(res => res.data)
	},
	setHabitsFavorite: ({ userId, payload }) => {
		return axiosInstance.post(end.getHabits({ userId }), payload).then(res => res.data)
	},
	setChallengeDone: ({ payload, userId }) =>
		axiosInstance.post(end.setChallengeDone({ userId }), payload).then(res => res.data),
	getTips: ({ userId }) => {
		return axiosInstance.get(end.getMarkedTip({ userId })).then(res => res.data)
	},
	setMarkTip: ({ payload }) => axiosInstance.post(end.markTip, payload).then(res => res.data)
}

export default HabitsService
